import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-step',
  standalone: false,
  template: `
    <div class="card flex flex-col gap-4 w-full max-w-4xl">
      <div class="font-semibold text-xl">{{ title }}</div>
      <ng-content></ng-content>
    </div>
  `,
})
export class FormStepComponent {
  @Input() title: string = '';
}
